export default {
  "translation": {
    "card_application": "卡片申請",
    "card_application_des": "申請您的Sonic卡，可在全球4400多萬支持Visa的商戶使用。",
    "spend_your_crypto_like_fiat": "像法幣一樣使用你的加密貨幣",
    "use_globally_across_borders": "全球使用，跨越邊界",
    "ultra_low_trans_costs": "超低交易成本",
    "seamless_and_secure": "無縫且安全",
    "two_factor_verification": "雙因素驗證",
    "two_factor_verification_des": "使用電子郵件件、電話、生物識別和/或身份驗證器應用程序安全登錄",
    "safety_pin": "安全 PIN",
    "safety_pin_des": "通過設置 PIN 限制訪問私人信息",
    "trans_3ds_verification": "3DS 驗證",
    "trans_3ds_verification_des": "在處理之前授權購買",
    "additional_security": "額外的安全性",
    "additional_security_des": "在應用程序上輕鬆設置卡限額和其他安全功能",
    "get_your_redotpay_card_in_steps": "通過三個簡單步驟獲取你的 Sonic 卡。",
    "get_your_redotpay_card_subtitle": "像法幣一樣使用加密貨幣：被全球 44M+ 支持 Visa 的商戶接受。",
    "continue_key": "繼續",
    "bind_your_mobile_number": "綁定你的手機號碼",
    "complete_identity_verification": "完成身份驗證",
    "apply_a_virtual_or_physical_card": "申請虛擬或實體卡",
    "transactions": "交易",
    "need_mobile_bind_confirm": "需要先綁定手機",
    "info": "信息",
    "card_trans_status_refund_pending": "退款待處理",
    "card_trans_status_refund_success": "退款成功",
    "card_trans_status_refund_fail": "退款失敗",
    "card_trans_status_refund_wait": "退款等待",
    "card_trans_status_pending": "已授權",
    "card_trans_status_cleared": "已結算",
    "card_trans_status_declined": "已拒絕",
    "card_trans_status_canceled": "已撤銷",
    "card_trans_status_refund": "退款",
    "card_trans_status_refund_cancel": "取消退款",
    "refund": "退款",
    "transaction_list": "交易列表",
    "more": "更多",
    "top_questions": "熱門問題",
    "faq": "常見問題",
    "self_service": "自助服務",
    "support_center": "帮助中心",
    "hello": "你好",
    "updated_on": "更新於",
    "chat_with_us": "與我們聊天",
    "warning": "警告",
    "security_option_change_alert_prompt": "解綁/修改 Google 身份驗證器/手機/電子郵件/PIN 後，提幣和內部轉賬將被禁用，卡交易將在接下來的 24 小時內每筆交易限額為 1000 美元，以確保安全。",
    "cancel": "取消",
    "ok": "確定",
    "account_deletion_regret_promp": "賬戶刪除允許你有 15 天的後悔期。當你在申請刪除後的 15 天內再次登錄時，你的申請將被取消，你的賬戶可以繼續正常使用。",
    "view_on_blockchain_explorer": "在區塊鏈瀏覽器上查看",
    "biz_sn": "交易編號",
    "type": "類型",
    "create_time": "創建時間",
    "logout_confirm": "你確定要退出登錄嗎？",
    "wallet": "錢包",
    "continue_with_google": "繼續使用 Google",
    "insufficient_balance_deposit_guide": "餘額不足。存入資產，否則你的交易將被拒絕，並可能收取費用。",
    "to": "到",
    "bill_will_be_sent_to": "賬單將發送到",
    "bill_statement": "賬單聲明",
    "export_bill": "導出賬單聲明",
    "this_month": "本月",
    "last_month": "上個月",
    "last_3_month": "最近 3 個月",
    "this_year": "今年",
    "last_year": "去年",
    "customize": "自定義",
    "bill_export_success": "賬單聲明已發送到你的電子郵件，請檢查",
    "bill_empty": "你的賬單為空",
    "channel": "渠道",
    "merchant_country": "商戶國家",
    "status": "狀態",
    "withdraw_detail": "提幣詳情",
    "new_key": "新增",
    "deposit": "充值",
    "withdraw": "提幣",
    "single_limit": "單筆限額",
    "all": "全部",
    "minimum": "最低",
    "available": "可用",
    "received_amount": "收到金額",
    "withdrawl": "提幣",
    "network_fee": "網絡費用",
    "register": "註冊",
    "register_login": "註冊/登錄",
    "login": "登錄",
    "email_Phone": "電子郵件/電話號碼",
    "email": "電子郵件",
    "mobile": "手機",
    "next": "下一步",
    "or_continue_with": "或繼續使用",
    "forgot_pw": "忘記密碼？",
    "welcome_to_redotpay": "歡迎來到 Sonic Pay",
    "verify_code": "驗證碼",
    "get_code": "獲取驗證碼",
    "by_creating_an_account": "通過創建賬戶，你同意我們的",
    "privacy_policy": "隱私政策",
    "terms_conditions": "條款和條件",
    "and": "和",
    "modify_pin": "更改 PIN",
    "pin_subtitle": "安全 PIN 提供快速驗證，使你可以輕鬆查看卡號和 CVV 信息。",
    "password_set_first_login": "首次登錄設置密碼",
    "next_step": "下一步",
    "confirm": "確認",
    "username": "用戶名",
    "password": "密碼",
    "send_code": "發送驗證碼",
    "send_code_to": "驗證碼將發送到",
    "switch_option": "更改驗證選項",
    "mobile_verification": "手機驗證",
    "email_verification": "電子郵件驗證",
    "choose_verify_method": "更改驗證選項",
    "verify_pin": "安全 PIN",
    "google_authenticator_verification": "Google 身份驗證器",
    "security": "安全",
    "bound": "已綁定",
    "unbound": "未綁定",
    "set": "設置",
    "unset": "未設置",
    "update_pw": "更改密碼",
    "delete_account": "註銷賬號",
    "google_authenticator": "Google 身份驗證器",
    "google_authenticator_subtitle": "Google 身份驗證器保護你的提幣和賬戶。",
    "download_install": "下載",
    "download_install_prompt": "首先你需要下載並安裝身份驗證器應用程序（Google 身份驗證器）",
    "backup_key": "備份密鑰",
    "save_backup_key": "將此備份密鑰保存在安全位置",
    "google_authenticator_code": "Google 身份驗證器code碼",
    "email_subtitle": "電子郵件驗證保護你的提幣和賬戶。",
    "change_email": "更改電子郵件",
    "email_update": "電子郵件更新",
    "code": "驗證碼",
    "mobile_subtitle": "手機驗證保護你的提幣和賬戶。",
    "change_mobile": "更改手機",
    "mobile_update": "手機更新",
    "mobile_bind": "綁定手機",
    "email_bind": "綁定電子郵件",
    "old_password": "舊密碼",
    "new_password": "新密碼",
    "new_password_confirm": "確認新密碼",
    "language": "語言",
    "appearance": "外觀",
    "logout": "退出登錄",
    "log_out_toast": "你已退出登錄",
    "set_pin": "安全 PIN",
    "account_deletion_prompt_1": "此賬戶將無法恢復",
    "account_deletion_prompt_2": "所有由此賬戶創建的子用戶/其他賬戶將被刪除且無法恢復。",
    "account_deletion_prompt_3": "與此賬戶關聯的所有 API 密鑰將被刪除。",
    "account_deletion_prompt_4": "此賬戶的所有當前委託和待處理的貨幣提幣將被取消。",
    "account_deletion_prompt_5": "此賬戶的所有交易功能將被禁用。",
    "account_deletion_prompt_6": "未從此賬戶提取的資產將被視為自願放棄的資產。",
    "account_deletion_prompt_7": "在你刪除賬戶申請後，你可以有 15 天的撤回期。當你在刪除請求後的 15 天內再次登錄時，你的刪除請求將被取消，賬戶可以繼續使用。",
    "kyc_status_0": "未提交",
    "kyc_status_1": "驗證中...",
    "kyc_status_2": "已批准",
    "kyc_status_3": "審核失敗",
    "kyc_status_4": "重新提交",
    "kyc_status_5": "提交給上游",
    "personal_info_review": "個人信息審核",
    "additional_info_request": "需要提供額外信息",
    "verifying": "驗證中...",
    "form_submitted_will_review_asap_new": "你的申請已提交進行人工審核。該過程通常需要 3-5 天，但有時可能需要更長時間。請耐心等待。",
    "get_verified": "身份驗證",
    "kyc_verified": "用戶身份已驗證",
    "approved": "審核通過",
    "not_able_to_submit_identity": "作為我們綜合審查流程的一部分，我們需要您提供額外信息，以完成了解客戶（KYC）和反洗錢（AML）的篩選程序。",
    "aml_review_failed": "為了繼續您的申請，請點擊下面的按鈕完成自我聲明表單填寫。",
    "aml_declaration_prompt": "請注意，未能在接下來的14天內提供所請求的表單會導致您的申請被拒絕。",
    "verify_your_identity": "驗證你的身份",
    "get_identity_verified": "驗證你的身份以購買和使用卡",
    "country_region": "國家/地區",
    "given_name": "名字",
    "surname": "姓氏",
    "date_of_birth": "出生日期",
    "document_type": "證件類型",
    "document_number": "證件號碼",
    "given_name_intl": "名字（國際）",
    "surname_intl": "姓氏（國際）",
    "click_to_add_signature": "點擊添加簽名",
    "rewrite": "重寫",
    "submit": "提交",
    "save": "保存",
    "accounts_are_not_available": "賬戶不可用",
    "abandon_assets": "放棄 {{amount}} {{currency}} 資產",
    "account_deletion_successful": "賬戶刪除成功",
    "passwords_do_not_match": "密碼不匹配",
    "password_reset_success": "密碼重置成功",
    "password_confirm": "確認密碼",
    "is_refund": "退款",
    "total_debt": "總債務",
    "your_account_is_in_arrears": "你的賬戶欠費。請存入足夠的資金以結清餘額。當你的餘額在還清債務後≥10美元時，你的賬戶/卡將恢復。",
    "repayment": "還款",
    "debit_record": "借記記錄",
    "no_data": "無數據",
    "payment": "支付",
    "transaction_details": "交易詳情",
    "transaction_date": "交易日期",
    "transaction_id": "交易 ID",
    "view_linked_order": "查看關聯訂單",
    "rights_interests": "權益",
    "transaction_limit": "交易限額",
    "deposit_withdraw": "充值和提幣",
    "card_purchased_number": "可購買的卡數量",
    "on_review_your_applicant": "我們正在審核你的申請",
    "form_en_only": "表格只能用英文填寫",
    "available_to_spend": "可用餘額",
    "get_a_card": "獲取 Sonic 卡，並在全球 44M+ 支持 Visa 的商戶使用。",
    "virtual_card": "虛擬卡",
    "physical_card": "實體卡",
    "apply_card": "申請卡",
    "enjoy_seamless_spending": "享受無縫消費",
    "spend_and_withdraw": "享受無縫消費和 ATM 提幣",
    "card_labeling": "卡標籤",
    "card_tag": "卡片標籤",
    "edit_billing_address": "修改賬單地址",
    "government_issued_id": "政府簽發的身份證",
    "facial_recognition": "面部識別",
    "address": "地址",
    "personnel_information_details": "個人信息詳情",
    "nation_list": "國家列表",
    "choose_channel": "驗證模式",
    "mobile_channel_sms": "短信",
    "mobile_channel_smsAliyunWhatsApp": "WhatsApp",
    "card_application_order": "申請卡片訂單",
    "promo_code_optional": "優惠碼（可選）",
    "promo_code": "優惠碼",
    "billing_address": "賬單地址",
    "shipping_address": "郵寄地址",
    "shipping_to": "郵寄到",
    "card_purchase_fee": "卡購買費用",
    "card_holder_name": "持卡人姓名",
    "city": "城市",
    "province_state": "省/州",
    "postal_code": "郵編/郵政編碼",
    "address_line1": "地址",
    "address_line2": "地址行 2",
    "please_fill_in_the_information_in_english": "表格只能用英文填寫",
    "first_name": "名字",
    "last_name": "姓氏",
    "country_code": "國家代碼",
    "card_application_list": "卡片申請列表",
    "buy_virtual_card": "購買虛擬卡",
    "buy_physical_card": "購買實體卡",
    "withdraw_list": "提幣列表",
    "no_more_data": "沒有更多數據",
    "select_a_network": "選擇一個網絡",
    "please_select_network": "請選擇一個網絡",
    "select_a_network_ensure": "確保你選擇的充值網絡與提幣網絡匹配，否則資產可能會丟失。",
    "network": "網絡",
    "card_management": "卡片管理",
    "freeze": "凍結",
    "unfreeze": "解凍",
    "freeze_card_des": "啟用一鍵卡鎖功能後，你將無法使用此卡，但不會影響其他卡。如果你想取消一鍵卡鎖功能，可以在這裡再次啟用。",
    "freezing_trades": "凍結卡會產生失敗訂單，導致交易失敗或因拒絕交易而產生額外費用",
    "unfreeze_your_card_desc": "禁用一鍵卡鎖功能後，你將可以再次使用此卡，並且不會影響其他卡。如果你想凍結卡，可以在這裡再次進行。",
    "card_tag_set_success": "卡標籤設置成功",
    "bill": "賬單",
    "setting": "設置",
    "limit": "限額",
    "assets_list": "資產列表",
    "empty_data": "無數據",
    "deposit_list": "充值列表",
    "date": "日期",
    "merchant_city": "商戶城市",
    "card_number": "卡號",
    "card_type": "卡類型",
    "mcc": "MCC",
    "declined_reason": "拒絕原因",
    "card_authorization_payment": "卡授權支付",
    "declined_transaction_fee": "拒絕交易費用",
    "verified": "已驗證",
    "notifications": "通知",
    "need_to_add_bill_address": "需要添加賬單地址",
    "need_to_add_shipping_address": "需要添加配送地址",
    "success": "成功",
    "welcome_redotpay": "歡迎來到 Sonic Pay！",
    "reset_pw_alert": "更改密碼後，提幣和內部轉賬將被禁用，卡交易將在接下來的 24 小時內每筆交易限額為 1000 美元，以確保安全。",
    "no_more_records": "沒有更多記錄",
    "add": "添加",
    "address_label": "地址標籤",
    "add_address": "添加地址",
    "this_field_is_required": "此字段為必填項",
    "ID_CARD": "身份證",
    "PASSPORT": "護照",
    "DRIVERS": "駕駛執照",
    "RESIDENCE_PERMIT": "居住證",
    "amount": "金額",
    "withdraw_status_waiting": "等待中",
    "withdraw_status_pending": "待處理",
    "withdraw_status_success": "成功",
    "withdraw_status_fail": "失敗",
    "withdraw_status_canceled": "已取消",
    "withdraw_status_declined": "被拒絕",
    "withdraw_status_complete": "已完成",
    "order_id": "訂單編號",
    "click_or_scroll_to_load_more": "點擊或滾動加載更多",
    "minimum_deposit_amount": "最低充值金額",
    "deposit_arrival_confirmations": "充值到達：{{confirmations}} 次確認",
    "confirmations": "{{confirmations}} 次確認",
    "deposit_network": "充值網絡",
    "minimum_deposit": "最低充值",
    "deposit_arrival": "充值到達",
    "current_address_supports_depositing": "當前地址僅支持在 {{displayName}} 上存入 {{varietyCode}}，其他資產將丟失。",
    "copy_successful": "複製成功",
    "update_password_successful": "密碼更新成功",
    "update_successful": "更新成功",
    "successful": "成功",
    "signature_required": "需要簽名",
    "deposit_successful": "充值成功",
    "sign_out": "登出",
    "cancel_withdraw_order_success": "取消提幣訂單成功",
    "delete_successful": "刪除成功",
    "unfreeze_card_successful": "解凍卡成功",
    "card_nickname_set_success": "卡暱稱設置成功",
    "trans_limit_adjusted_success": "交易限額調整成功",
    "set_card_pin_success": "設置卡 PIN 成功",
    "withdraw_apply_commit_please_wait": "提幣申請已提交，請稍候",
    "unfreeze_success": "解凍成功",
    "freeze_success": "凍結成功",
    "withdraw_duration_tip": "提幣申請將在一個工作日內處理",
    "you_will_withdraw": "你將提幣",
    "withdraw_info": "提幣信息",
    "please_confirm_same_network": "確保你選擇的充值網絡與充值網絡匹配，否則資產可能會丟失。",
    "cancel_withdraw_order_confirm": "你確定要取消提幣訂單嗎？",
    "valid_thru": "有效期至",
    "last_7_days": "最近 7 天",
    "last_30_days": "最近 30 天",
    "today": "今天",
    "all_done": "全部完成",
    "view_details": "查看詳情",
    "withdraw_success": "提幣成功",
    "pay": "支付",
    "fee": "費用",
    "discount": "優惠",
    "price": "價格",
    "card_application_details": "卡片申請詳情",
    "card_pin": "卡片PIN碼",
    "card_pin_format_helper": "不能包含三個連續相同的數字或連續的數字",
    "digit_variable": "{{count}} 位",
    "address_book": "地址簿",
    "unlimited": "無限額",
    "single": "單筆",
    "update_card_pin": "更新卡PIN碼",
    "set_card_pin": "設置卡PIN碼",
    "report_lost": "卡片掛失",
    "report_lost_card": "卡片掛失",
    "card_lost_report_alert": "卡掛失後您將不能解除掛失狀態，卡片變為不可用狀態，如想再次使用卡片或申請換卡請聯繫客服。",
    "pending": "待處理",
    "frozen": "凍結",
    "phone_number": "手機號碼",
    "search": "檢索",
    "reset": "重置",
    "total_amount": "總金額",
    "actual_amount": "實際金額",
    "already_have_an_account": "已有賬戶？",
    "create_account": "註冊Sonic Pay新用戶",
    "total_balance": "總餘額",
    "cards_balance_available_promp": "根據錢包資產實時計算的信用額度",
    "got_it": "知道了",
    "review_details": "確認信息",
    "delete_this_address": "確定刪除此地址?",
    "currency": "貨幣",
    "merchant_name": "商家名稱",
    "request_time": "請求時間",
    "is_transaction_allowed": "此交易是否允許？",
    "approve": "批准",
    "decline": "拒絕",
    "card_in_production": "卡片生產中",
    "redotpay_card_sent": "Redotpay卡已寄出",
    "redotpay_card_activated": "Redotpay卡已啟用",
    "activate_card": "啟用卡片",
    "paste": "貼上",
    "fees_included": "費用包含",
    "fx_fee": "外匯手续費",
    "small_auth_fee": "小額交易費",
    "atm_fee": "ATM費",
    "received": "已接收",
    "incremental": "追加",
    "bill_address_save_success": "賬單地址保存成功",
    "no_more_trans_record": "沒有更多交易記錄",
    "withdraw_amount_larger_than_available": "超過最大可用餘額",
    "withdraw_lower_than_min": "低於最低提款額",
    "card_is_deleted": "卡片已刪除",
    "something_error": "出錯了",
    "home": "首頁",
    "select_country": "選擇國家",
    "billing_list": "賬單列表",
    "coupon_code": "優惠碼",
    "password_rule1": "8至32個字元",
    "password_rule2": "至少一個大寫英文字母",
    "password_rule3": "至少一個小寫英文字母",
    "password_rule4": "至少一個數字",
    "set_pw": "設定密碼",
    "payment_currency_settings": "支付貨幣設置",
    "customize_payment_currency": "自訂付款貨幣",
    "disable_non_local_tip": "禁用非本地貨幣的交易可有效降低銀行卡盜刷風險",
    "charging_rules": "計費規則",
    "reissue_card": "補卡發卡",
    "update_cvv": "更新CVV碼",
    "update_cvv_desc": "相同卡號，新的CVV、以及新的效期。",
    "fx_fee_desc": "外匯手續費（FX費）包括1.2%的非默認貨幣交易手續費。 （如適用）",
    "atm_fee_desc": "每筆ATM取款將收取2%的附加費用",
    "remit_fee_desc": "使用 Visa 信用卡或借記卡支付時所需的費用。",
    "risk_safety_tips": "安全提示",
    "risk_safety": "為安全起見，請先在應用程式上完成人臉識別驗證，再進行任何相關操作。",
    "go_to_app_verify": "前往應用程式驗證",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "立即去 RedotPay",
    "close": "關閉",
    "card_cancellation": "卡取消",
    "delete_card": "刪除卡片",
    "delete_card_desc": "刪除後，該卡將無法使用，且此操作不可逆。",
    "deleting_fee": "刪除費用",
    "currency_tips": "貨幣提示",
    "at_least_one_currency": "請至少保留一種可支付的貨幣。",
    "all_select_currency": "您已經支援所有貨幣以完成交易。",
    "small_auth_transaction_fee_stas": "小額交易費詳情",
    "small_transactions_this_month": "當月小額交易",
    "small_autn_trans_remain": "當月小額交易豁免次數",
    "rules": "規則",
    "failed_rules": "交易失敗將增加不良交易記錄的數量，超出豁免數後將收取額外費用。請規範交易。",
    "rule_item": "項目",
    "free_count": "免費次數",
    "fees": "費用",
    "declined_trans_remain": "當月拒絕交易豁免次數",
    "declined_transaction_fee_stats": "拒絕交易費詳情",
    "declined_rules": "交易失敗將增加不良交易記錄的數量，超出豁免數後將收取額外費用。請規範交易。",
    "declined_transactions_this_month": "當月拒絕交易次數",
    "reissue_fee": "補發費用",
    "card_trans_detail_status_refund": "退款處理中",
    "card_trans_status_reversal": "撤銷",
    "card_trans_status_fully_refund": "已處理, 全部退款",
    "card_trans_status_partial_refund": "已處理, 部分退款",
    "card_trans_status_void": "無效",
    "first_time_free": "首次免費",
    "FxFee": "外匯費",
    "AtmFee": "ATM費",
    "RemitFee": "匯款費",
    "MccFee": "特別商戶手续費",
    "SmallAuthFee": "小额交易费",
    "mcc_fee_desc": "部分商户会收取交易金额 1.5% 的额外费用。如果费用低于 0.5 美元，将收取最低 0.5 美元的费用。",
    "please_deposit": "余额不足，请充值",
    "special_mcc_fee": "特别商户交易费",
    "bank_verifying": "這筆退款銀行正在審核中……",
    "estimate_time": "預計到賬2-30天",
    "delete_out": "註銷",
    "card_is_loss": "卡片已掛失",
    "incremental_desc": "如果授權金額不足，會產生追加收費，相關金額將在結算時添加。",
    "card_trans_status_fully_refund1": "已結算",
    "card_trans_status_fully_refund2": "全额退款",
    "card_trans_status_partial_refund1": "已結算",
    "card_trans_status_partial_refund2": "部分退款",
    "review_takes_time": "審核時間約為 2 分鐘至 24 小時。",
    "custom_date_null": "請選擇自定義日期",
    "custom_date_error": "請設定正確的查詢時間",
    "small_trade_fee": "小额交易手續費",
    "user_risk_exception": "用戶狀態異常",
    "request_exception": "請求結果錯誤",
    "mobile_is_not_empty": "請輸入正確的手機號碼",
    "code_is_not_empty": "請輸入正確的驗證碼"
  }
};